module.exports = __webpack_public_path__ + "img/9788995683637.d79d0332.jpg";